module.exports = __webpack_public_path__ + "static/media/skywalker-yoda-vader.61a7d8de.png";